import type { ResultadoDeLote } from '../types/price-proposals.types';

/**
 * `approve-batch` y `discard-batch` toman como mucho 200 ids por pedido
 * (`TOPE_LOTE`, price-proposals.routes.ts) y recortan el resto. La vuelta de una
 * estrategia grande pasa de 200: se parte en pedidos y se suman los resultados.
 */
export const TOPE_POR_PEDIDO = 200;

export function partirEnLotes<T>(ids: T[], tamano = TOPE_POR_PEDIDO): T[][] {
  const lotes: T[][] = [];
  for (let i = 0; i < ids.length; i += tamano) lotes.push(ids.slice(i, i + tamano));
  return lotes;
}

export function sumarLotes(resultados: ResultadoDeLote[]): ResultadoDeLote {
  const porDesenlace: ResultadoDeLote['porDesenlace'] = {};
  for (const r of resultados) {
    for (const [k, n] of Object.entries(r.porDesenlace)) {
      const clave = k as keyof ResultadoDeLote['porDesenlace'];
      porDesenlace[clave] = (porDesenlace[clave] ?? 0) + (n ?? 0);
    }
  }
  return {
    total: resultados.reduce((n, r) => n + r.total, 0),
    porDesenlace,
    resultados: resultados.flatMap((r) => r.resultados),
    recortadas: resultados.reduce((n, r) => n + r.recortadas, 0),
  };
}
